import { TagInterface } from 'riot';
import { retrieveLandRegistry } from '../../actions/landRegistry';
import * as landRegistryConstants from '../../constants/landRegistry';
import landRegistryStore from '../../stores/landRegistry';
import { LandRegistryPartAndState } from '../../typings/LandRegistryLookup';

const { events: landRegistryEvents } = landRegistryConstants;

const loadLandRegistry = (propertyKey: string, landRegistryToMount: LandRegistryPartAndState): void => {
  retrieveLandRegistry(landRegistryToMount.landRegistryPart, propertyKey, landRegistryToMount.landRegistryState);
};

export const init = (tag: TagInterface): void => {
  const triggerLoadFinish = (): void => {
    tag.opts.onTaskDone();
    tag.update();
  };

  tag.on('mount', () => {
    landRegistryStore.on(landRegistryEvents.LAND_REGISTRY_LOADING_COMPLETE, triggerLoadFinish);
    loadLandRegistry(tag.opts.propertyKey, tag.opts.componentsToMount);
  });

  tag.on('unmount', () => {
    landRegistryStore.off(landRegistryEvents.LAND_REGISTRY_LOADING_COMPLETE, triggerLoadFinish);
  });
};
